export function sanitizeList(list) {
  return list.filter(item => item !== null && item !== undefined);
}
